import { DeviceModelId } from "@ledgerhq/devices";
import { supportedDeviceModelIds, } from "../capabilities/isCustomLockScreenSupported";
const NO_PADDING = {
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
};
export const SCREEN_SPECS = {
    [DeviceModelId.stax]: {
        width: 400,
        height: 672,
        ...NO_PADDING,
        paddingBottom: 2,
    },
    [DeviceModelId.europa]: {
        width: 480,
        height: 600,
        ...NO_PADDING,
    },
};
export function getScreenSpecs(deviceModelId) {
    return SCREEN_SPECS[deviceModelId];
}
const screenDataDimensions = supportedDeviceModelIds.reduce((acc, deviceModelId) => {
    const { width, height } = SCREEN_SPECS[deviceModelId];
    acc[deviceModelId] = { width, height };
    return acc;
}, {});
export function getScreenDataDimensions(deviceModelId) {
    return screenDataDimensions[deviceModelId];
}
const screenVisibleAreaDimensions = supportedDeviceModelIds.reduce((acc, deviceModelId) => {
    const { width, height, paddingTop, paddingBottom, paddingLeft, paddingRight } = SCREEN_SPECS[deviceModelId];
    acc[deviceModelId] = {
        width: width - paddingLeft - paddingRight,
        height: height - paddingTop - paddingBottom,
    };
    return acc;
}, {});
/**
 *
 * @param deviceModelId
 * @returns the dimensions of the visible area of the screen (without padding)
 */
export function getScreenVisibleAreaDimensions(deviceModelId) {
    return screenVisibleAreaDimensions[deviceModelId];
}
//# sourceMappingURL=screenSpecs.js.map